import React from 'react'
import Reveal from './Reveal'

const logosTop = [
  { src: '/logo/AXA2.png', name: 'AXA' },
  { src: "/logo/L'oréal.png", name: "L'Oréal" },
  { src: '/logo/bnp-cardif.svg', name: 'BNP Paribas Cardif' },
  { src: '/logo/Banque_de_France.png', name: 'Banque de France' },
  { src: '/logo/vivendi.svg', name: 'Vivendi' },
  { src: '/logo/credit-agricole-immobilier.png', name: 'Crédit Agricole Immobilier' },
  { src: '/logo/ErnstYoung.png', name: 'Ernst & Young' },
]
const logosBottom = [
  { src: '/logo/HOPSCOTCHGROUPE.png', name: 'Hopscotch Groupe' },
  { src: '/logo/CNC.svg', name: 'CNC — Centre national du cinéma' },
  { src: '/logo/agefiph.svg', name: 'Agefiph' },
  { src: '/logo/Nanterre.svg', name: 'Ville de Nanterre' },
  { src: '/logo/Région_Île-de-France.png', name: 'Région Île-de-France' },
  { src: '/logo/HOPITAL_FOCH.png', name: 'Hôpital Foch' },
  { src: '/logo/fondation-malakoff.png', name: 'Fondation Malakoff Humanis' },
]

const MarqueeRow = ({ logos, reverse = false }) => (
  <div className="edge-fade overflow-hidden py-2">
    <div
      className="flex w-max items-center gap-5 animate-infinite-scroll"
      style={reverse ? { animationDirection: 'reverse' } : undefined}
    >
      {/* La 2e moitié est une duplication visuelle pour le défilement infini :
          elle est masquée aux technologies d'assistance pour éviter les doublons. */}
      {[...logos, ...logos].map((logo, i) => {
        const decorative = i >= logos.length
        return (
          <div
            key={i}
            className="group grid h-20 w-44 shrink-0 place-items-center rounded-2xl border border-white/[0.06] bg-white/[0.02] px-6 transition-colors hover:border-white/15 hover:bg-white/[0.05]"
          >
            <img
              src={logo.src}
              alt={decorative ? '' : logo.name}
              aria-hidden={decorative || undefined}
              className="max-h-9 max-w-[7rem] object-contain white-icon opacity-55 transition-all duration-500 group-hover:opacity-100"
            />
          </div>
        )
      })}
    </div>
  </div>
)

function Partenaire() {
  return (
    <section className="relative py-20 lg:py-24" id="Partenaire">
      <div className="container-pdv">
        <Reveal className="text-center max-w-2xl mx-auto mb-12">
          <span className="eyebrow justify-center">Ils nous font confiance</span>
          <h2 className="mt-5 font-display font-extrabold leading-[1.05] text-[clamp(1.8rem,3.6vw,2.8rem)]">
            Des marques <span className="text-gradient">qui comptent</span>
          </h2>
          <p className="mt-4 text-[#a99bd0]">
            Grands groupes, institutions publiques et acteurs de la culture nous confient leurs projets.
          </p>
        </Reveal>
      </div>

      <Reveal className="space-y-3">
        <MarqueeRow logos={logosTop} />
        <MarqueeRow logos={logosBottom} reverse />
      </Reveal>
    </section>
  )
}

export default Partenaire
